import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/inspector")({
  component: lazyRouteComponent(() => import("@/pages/admin/Inspector")),
});
